import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Instagram } from "lucide-react";
import { Wordmark } from "./Wordmark";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-ink text-sand text-right">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-24">
        <div className="grid md:grid-cols-12 gap-12 items-end">
          <div className="md:col-span-7">
            <p className="text-xs uppercase tracking-[0.3em] font-bold text-teal mb-8">
              Sustainable · Inclusive · Wellness-focused
            </p>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tight">
              Have a plot,
              <br />
              <span className="italic text-stone">a dream, a brief?</span>
            </h2>
            <Link
              to="/quiz"
              data-testid="footer-cta-button"
              className="inline-block mt-10 text-sm uppercase tracking-[0.2em] font-bold border border-sand/30 px-8 py-4 hover:bg-sand hover:text-ink transition-colors duration-500"
            >
              Take the Quiz
            </Link>
          </div>
          <div className="md:col-span-5 md:text-right space-y-6">
            <div>
              <p className="text-xs uppercase tracking-[0.2em] text-sand/50 mb-2">Studio</p>
              <p className="text-base text-sand/90">No.12, Hema Nivas, Byrasandra Main Rd,<br />1st Block East, 1st Block, Jayanagar,<br />Bengaluru, Karnataka 560011</p>
              <a
                href="https://maps.app.goo.gl/7Uhh9ckfSVTRNu8B8"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-map-link"
                className="mt-3 inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-teal hover:text-sand transition-colors"
              >
                <MapPin size={13} />
                View on Google Maps
              </a>
            </div>
            <div>
              <p className="text-xs uppercase tracking-[0.2em] text-sand/50 mb-2">Enquiries</p>
              <a href="mailto:hello.bluegreen.studio@gmail.com" className="link-underline text-base text-sand/90">
                hello.bluegreen.studio@gmail.com
              </a>
            </div>
            <div>
              <p className="text-xs uppercase tracking-[0.2em] text-sand/50 mb-2">Follow</p>
              <a
                href="https://www.instagram.com/bluegreen_studio.in"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram-link"
                className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-teal hover:text-sand transition-colors"
              >
                <Instagram size={13} />
                @bluegreen_studio.in
              </a>
            </div>
          </div>
        </div>
        <div className="mt-20 pt-8 border-t border-sand/10 flex flex-col md:flex-row justify-between gap-4 items-start md:items-center">
          <div className="flex items-center gap-4">
            <Wordmark size="md" invert />
            <span className="text-xs uppercase tracking-[0.2em] text-sand/40">© {new Date().getFullYear()}</span>
          </div>
          <Link to="/insights" className="text-xs uppercase tracking-[0.2em] text-sand/60 hover:text-sand transition-colors mr-6">
            Insights
          </Link>
          <Link to="/login" data-testid="footer-admin-link" className="text-xs uppercase tracking-[0.2em] text-sand/40 hover:text-sand transition-colors">
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
};
